(function () {


const sizes = {
  single: [],
  twin: [
    {weight: '<50kg',   board: '<5\'6"',      suggestion: 'M'},
    {weight: '50-70kg', board: '5\'6"-6\'6"', suggestion: 'M'},
    {weight: '70-90kg', board: '6\'6"-7\'6"', suggestion: 'L'},
    {weight: '>100kg',  board: '>7\'6"',      suggestion: 'L'},
  ],
  keel: [
    {weight: '<50kg',   board: '<5\'0"',      suggestion: 'M'},
    {weight: '50-70kg', board: '5\'0"-6\'4"', suggestion: 'M'},
    {weight: '70-90kg', board: '6\'4"-7\'6"', suggestion: 'L'},
    {weight: '>100kg',  board: '>7\'6"',      suggestion: 'L'},
  ],
  thruster: [
    {weight: '<50kg',   board: '<5\'2"',      suggestion: 'S'},
    {weight: '50-70kg', board: '5\'2"-6\'2"', suggestion: 'M'},
    {weight: '70-90kg', board: '6\'2"-7\'2"', suggestion: 'M'},
    {weight: '>100kg',  board: '>7\'2"',      suggestion: 'L'},
  ],
  quad: [],
  twoplusone: [],
}




function get_fin_type_from_product_title () {
  const title = window_api_data.product_title.toLowerCase();
  if (title.indexOf('single') != -1) {
    return 'single';
  }
  if (title.indexOf('2 + 1') != -1) {
    return 'twoplusone';
  }
  if ((title.indexOf('twin') != -1)) {
    return 'twin';
  }
  if (title.indexOf('keel') != -1) {
    return 'keel';
  }
  if (title.indexOf('thruster') != -1) {
    return 'thruster';
  }
  if (title.indexOf('quad') != -1) {
    return 'quad';
  }
  console.log("no fin type found for product title: ", window_api_data.product_title);
  return null;
}


function render_fin_audio (root_el) {
  const title = window_api_data.product_title.toLowerCase();

  let type;

  if (title.indexOf('single') != -1) {
    type = 'single';
  }
  if ((title.indexOf('twin') != -1)) {
    type = 'twin';
  }
  if (title.indexOf('keel') != -1) {
    type = 'keel';
  }
  if (title.indexOf('thruster') != -1) {
    type = 'thruster';
  }
  if (title.indexOf('quad') != -1) {
    type = 'quad';
  }

  if (!type) {
    console.log("Cannot choose audio: no fin type found for product title: ", window_api_data.product_title);
  }

  const fin_audio_el = document.createElement('div');
  fin_audio_el.className = 'fin_audio';
  root_el.before(fin_audio_el);

  const audio = document.createElement('audio');
  audio.preload = 'auto';
  audio.src = window_api_data.audio_files[type];
  fin_audio_el.appendChild(audio);

  const listen_button = document.createElement('div');
  listen_button.className = 'listen_button';
  fin_audio_el.appendChild(listen_button);

  const play_image = document.createElement('img');
  play_image.className = 'play_image';
  play_image.src = window_api_data.play_png;
  play_image.width = 28;
  play_image.height = 32;
  listen_button.appendChild(play_image);

  const stop_image = document.createElement('div');
  stop_image.className = 'stop_image';
  listen_button.appendChild(stop_image);

  const listen_button_image = document.createElement('img');
  listen_button_image.className = 'listen_button_image';
  listen_button_image.src = window_api_data.audio_button_gif;
  listen_button_image.width = 150;
  listen_button_image.height = 86;
  listen_button.appendChild(listen_button_image);

  const listen_button_static_image = document.createElement('img');
  listen_button_static_image.className = 'listen_button_static_image';
  listen_button_static_image.src = window_api_data.audio_button_static_png;
  listen_button_static_image.width = 150;
  listen_button_static_image.height = 86;
  listen_button.appendChild(listen_button_static_image);

  const listen_button_text = document.createElement('div');
  listen_button_text.className = 'listen_button_text';
  listen_button_text.innerText = 'listen to the audio';
  listen_button.appendChild(listen_button_text);

  let is_playing = false;
  listen_button.addEventListener('click', function () {
    if (is_playing) {
      audio.pause();
      audio.currentTime = 0;
      listen_button_text.innerText = 'listen to the audio';
      listen_button.classList.remove('active');
    } else {
      audio.play();
      listen_button_text.innerText = 'stop the audio';
      listen_button.classList.add('active');
    }
    is_playing = !is_playing;
  });


  audio.addEventListener('ended', function () {
    is_playing = false;
    audio.currentTime = 0;
    listen_button_text.innerText = 'listen to the audio';
    listen_button.classList.remove('active');
  });
}


function render_fin_size_chart (root_el, fin_type) {
  const fin_size_chart_el = document.createElement('div');
  fin_size_chart_el.className = 'fin_size_chart';
  root_el.appendChild(fin_size_chart_el);

  const cb_el = document.createElement('input');
  cb_el.className = 'toggle_cb';
  cb_el.type = 'checkbox';
  cb_el.checked = false;
  cb_el.id = 'fin_size_chart';
  cb_el.name = 'fin_size_chart';
  fin_size_chart_el.appendChild(cb_el);

  const label_el = document.createElement('label');
  label_el.className = 'toggle_label';
  label_el.setAttribute('for', 'fin_size_chart');
  fin_size_chart_el.appendChild(label_el);

  const chart_cont = document.createElement('div');
  chart_cont.className = 'chart_cont';
  fin_size_chart_el.appendChild(chart_cont);

  {
    const row_el = document.createElement('div');
    row_el.className = 'row';
    chart_cont.appendChild(row_el);

    const weight_col = document.createElement('div');
    weight_col.className = 'weight_col';
    weight_col.innerText = 'Weight';
    row_el.appendChild(weight_col);

    const board_col = document.createElement('div');
    board_col.className = 'board_col';
    board_col.innerText = 'Board size';
    row_el.appendChild(board_col);

    const suggestion_col = document.createElement('div');
    suggestion_col.className = 'suggestion_col';
    suggestion_col.innerText = 'Fin size';
    row_el.appendChild(suggestion_col);
  }

  for (let i=0; i<sizes[fin_type].length; i++) {
    const size = sizes[fin_type][i];

    const row_el = document.createElement('div');
    row_el.className = 'row';
    chart_cont.appendChild(row_el);

    const weight_col = document.createElement('div');
    weight_col.className = 'weight_col';
    weight_col.innerText = size.weight;
    row_el.appendChild(weight_col);

    const board_col = document.createElement('div');
    board_col.className = 'board_col';
    board_col.innerText = size.board;
    row_el.appendChild(board_col);

    const suggestion_col = document.createElement('div');
    suggestion_col.className = 'suggestion_col';
    suggestion_col.innerText = size.suggestion;
    row_el.appendChild(suggestion_col);
  }
  
  const recommendation_text = document.createElement('div');
  recommendation_text.innerHTML = "* This is a recommended size only. If you have any queries please <a href='"+window_api_data.root_url+"/pages/contact-us/'>contact customer service</a>.";
  recommendation_text.className = 'recommendation_text';
  chart_cont.appendChild(recommendation_text);
}


function render_fins_detail (previous_cont) {
  const fins_detail_el = document.createElement('div');
  fins_detail_el.className = 'fins_detail';
  previous_cont.after(fins_detail_el);

  const fin_type = get_fin_type_from_product_title();
  if (!fin_type) {
    return;
  }

  if (sizes[fin_type].length != 0) {
    render_fin_size_chart(fins_detail_el, fin_type);
  }
}

window.render_fins_detail = render_fins_detail;
window.render_fin_audio = render_fin_audio;

})();
